export function parseSparqlParams(query: string): string[] {
  let params: string[] = []
  let inSelect = false
  let inParentheses = 0
  let lastAliasParam: string | null = null
  let insideAlias = false

  const tokens = query
    .replace(/\r?\n/g,' ')
    .match(/\(|\)|\?[\w]+|as|\*|\w+|["'][^"']*["']|SELECT|WHERE|{|}/gi)

  if (!tokens) return []

  for (const token of tokens) {
    if (token.toUpperCase() === 'SELECT') {
      inSelect = true
      continue
    }

    if (token.toUpperCase() === 'WHERE' || token === '{') {
      break
    }

    if (inSelect) {
      if (token === '*') {
        if (inParentheses === 0) {
          return []
        }
      }
      if (token === '(') {
        inParentheses++
        if (!insideAlias) {
          insideAlias = true
          lastAliasParam = null
        }
      } else if (token === ')') {
        inParentheses--
        if (inParentheses === 0) {
          insideAlias = false
          if (lastAliasParam) {
            params.push(lastAliasParam)
          }
        }
      } else if (token.startsWith('?')) {
        const param = token.replace('?', '')
        if (insideAlias) {
          lastAliasParam = param
        } else {
          params.push(param)
        }
      }
    }
  }

  return params
}

// Poor man's testing framework
const runTest = false
if (runTest) {
  const cases = [
    {
      query: `
      SELECT ("user" as ?user)
      (?someone as ?friend)\r\n
      ?something
      ("cool" as ?isCool)
      ("" as ?icon)
      ?nice
      WHERE { ?s ?p ?o . }`,
      expected: 'user friend something isCool icon nice'
    },
    {
      query: `
      SELECT ?one ?two ?three
      ?four { ?five ?six ?seven . }`,
      expected: 'one two three four'
    },
    {
      query: 'SELECT (?var as ?alias) ?realParam WHERE { ?s ?p ?o . }',
      expected: 'alias realParam'
    },
    {
      query: 'select (?another as ?a) ?b ?c { { ?s1 ?p1 ?o1 . } union { ?s2 ?p2 ?o2 . }}',
      expected: 'a b c'
    },
    {
      query: 'select * where { ?s ?p ?o . } ',
      expected: ''
    },
    {
      query: `
      select ?a ?b (round(sum(?c) * 100) / 100 + 100 - 100 as ?d)
      where {
        values(?a ?b ?c) {
          ("a" "Aaaa" 0.23)
          ("b" "Bbbb" 2.00)
        }
      }
      `,
      expected: 'a b d'
    },
    {
      query: `
      SELECT ?month ?category
       (ROUND(SUM(?workableHours) * 100) / 100 AS ?totalWorkableHours)
       (ROUND(SUM(COALESCE(?billableHours, 0)) * 100) / 100 AS ?totalBillableHours)
       (ROUND((SUM(COALESCE(?billableHours, 0)) / SUM(?workableHours)) * 100 * 100) / 100 AS ?percentageBillableHours)
      WHERE {
        VALUES(?month ?category ?workableHours ?billableHours) {
          ("April" "Study" 100.0 undef)
          ("May" "Development" 220.0 50.0)
          ("May" "Consulting" 310.0 310.0)
        }
      }
      GROUP BY ?month ?category
      `,
      expected: 'month category totalWorkableHours totalBillableHours percentageBillableHours'
    }
  ]

  for (let i = 0; i < cases.length; i++) {
    const test = cases[i]
    const actual = parseSparqlParams(test.query).join(' ');
    const passed = actual === test.expected;
    console.log(`parseSparqlParams test ${i + 1} ${passed ? 'PASS' : 'FAIL'}`, {
      query: test.query,
      expected: test.expected,
      actual: actual
    })
  }
}
